import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
//header navbar
import MenuGuest from "./Menu";
import MenuLegged from "../../header/Menu"; 

function HeadBar(props) {
    const [menu, setMenu] = useState(props.menu)
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    // home, abount, information, contact, login
    const [width, setWidth] = useState(0);
    const [informationHover, setInformationHover] = useState(false);
    const[pharmacogenomicsHover, setPharmacogenomicsHover] = useState(false);
 
    const [userRole, setUserRole] = useState(
        JSON.parse(localStorage.getItem("user"))
    );

    useEffect(() => {
        const updateWindowDimensions = () => {
            const newWidth = window.innerWidth;
            setWidth(newWidth);
            // console.log("updating Width");
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)
    }, []);

    useEffect(() => {
        if (width > 767) {
            setOpen(false)
        }else if(width <= 767) {
            setOpen1(false)
        }
    }, [width])
     
    return (
      <>
        {userRole?.["auth"]["role"] ? (
          <MenuLegged menuActive={menu} />
        ) : (
          <MenuGuest menu={`${props.menu}`} />
        )}
        {/* userRole?.["auth"]["role"][0] == "PATIENT" ? (
            <NavPatient menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "MEDICAL_PERSONNEL" ? (
            <MenuDoctor menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "LABORATORY_PERSONNEL" ? (
            <MenuAdmin menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "LABORATORY_ADMIN" ? (
            <MenuAdmin menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "ADMIN" ? (
            <MenuAdmin menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "EXECUTIVE" ? (
            <MenuAdmin menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "HOSPITAL" ? (
            <MenuHospital menuActive={menu} />
          ) : userRole?.["auth"]["role"][0] === "HOSPITAL_PERSONNEL" ? (
            <MenuAdmin menuActive={menu} />
          ) : (
            <></>
          ) */}
      </>
    ); 
}

export default HeadBar